module.exports = __webpack_public_path__ + "img/4.b09d68c4.jpg";